class helpers
{
    // date - time
    initDateTime(datetime: string)
    {
        var mydate = new Date(datetime);

        return this.persianNumberToEnglishNumber(mydate.toLocaleDateString('fa-IR') + ' ' + mydate.toLocaleTimeString('fa-IR'));
    }

    initDateOfDateTime(datetime: string)
    {
        var mydate = new Date(datetime);

        return this.persianNumberToEnglishNumber(mydate.toLocaleDateString('fa-IR'));
    }

    initTimeOfDateTime(datetime: string)
    {
        var mydate = new Date(datetime);

        return this.persianNumberToEnglishNumber(mydate.toLocaleTimeString('fa-IR'));
    }

    persianNumberToEnglishNumber(str: string)
    {
        let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
        let arabicNumbers  = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];

        for (let i = 0; i < 10; i++)
        {
            str = str.replace(persianNumbers[i], i.toString()).replace(arabicNumbers[i], i.toString());
        }

        return str;
    }

    // init mobile
    initMobile(mobile: string)
    {
        mobile = mobile.trim();
        if(mobile.indexOf("0") === 0) mobile = mobile.substring(1);
        if(mobile.indexOf("98") === 0) mobile = mobile.substring(2);
        if(mobile.indexOf("+98") === 0) mobile = mobile.substring(3);

        return mobile !== "" ? "98" + mobile : "";
    }

    // check internet
    inOnline()
    {
        return typeof navigator !== 'undefined' ? navigator.onLine : false;
    }

    // check number
    inNumber(num: number)
    {
        return num >= 10 ? num : "0" + num;
    }

    // check is number
    isNumeric(value: any)
    {
        return /^-?\d+(\.\d+)?$/.test(value);
    }

    // send sms
    sendSms(mobileNumber: string, message: string)
    {
        if(window.hasOwnProperty("AndroidFunction"))
        {
            // @ts-ignore
            window.AndroidFunction.sendSms(mobileNumber, message);
        }
        else
        {
            // window.open("sms:" + mobileNumber + "?&body=" + encodeURIComponent(message));

            var a = document.createElement('a');
            var linkText = document.createTextNode("my title text");
            a.appendChild(linkText);
            a.title = "my title text";
            a.href = "sms:" + mobileNumber + "?&body=" + encodeURIComponent(message);
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
    }

    // init speed
    initSpeed(speed: number)
    {
        return speed > 0 ? (Math.round(speed * 1.852) * 100 / 100) : 0;
    }

    //
    haversineDistance(lat1: number, lon1: number, lat2: number, lon2: number)
    {
        const R = 6371;
        const toRad = (angle: number) => angle * (Math.PI / 180);

        let dLat = toRad(lat2 - lat1);
        let dLon = toRad(lon2 - lon1);
        let a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c;
    }

    calculateTotalDistance(locations: string | any[])
    {
        let totalDistance = 0;

        for (let i = 0; i < locations.length - 1; i++)
        {
            const { latitude: lat1, longitude: lon1 } = locations[i];
            const { latitude: lat2, longitude: lon2 } = locations[i + 1];

            totalDistance += this.haversineDistance(lat1, lon1, lat2, lon2);
        }

        return totalDistance;
    }

    // init position
    initPosition(position: number)
    {
        return position > 0 ? Math.round(position * 10000) / 10000 : 0;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new helpers();